import { getActiveApiBaseUrl } from '../api/apiBaseConfig';

/** Unwrap user object from API envelope ({ data: [...] } or nested shapes). */
export function extractApiUser(rd: unknown): Record<string, unknown> | null {
  if (!rd || typeof rd !== 'object') return null;
  const root = rd as Record<string, unknown>;
  if (root.data != null) {
    const d = root.data;
    if (Array.isArray(d) && d.length > 0 && d[0] && typeof d[0] === 'object') {
      return d[0] as Record<string, unknown>;
    }
    if (d && typeof d === 'object' && !Array.isArray(d)) {
      const obj = d as Record<string, unknown>;
      if (obj.id || obj.user_id) return obj;
    }
  }
  if (root.id || root.user_id) return root;
  return null;
}

/** Normalize profile image URL or base64 — matches OTS mobile / AppHeader behavior. */
export function normalizeProfileImage(
  img: string | null | undefined,
  baseURL = getActiveApiBaseUrl(),
): string | undefined {
  if (!img || typeof img !== 'string' || img.trim() === '') return undefined;
  const value = img.trim().replace(/\\/g, '/');
  if (value.startsWith('data:image')) return value;
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  const looksLikeRelativeFilePath = /^(uploads?|public|files?|images?|avatars?|profile-images?)\//i.test(value);
  if (value.startsWith('/') || looksLikeRelativeFilePath) {
    const base = (baseURL || '').replace(/\/$/, '');
    const path = value.startsWith('/') ? value : `/${value}`;
    return base ? `${base}${path}` : path;
  }
  return `data:image/png;base64,${value.replace(/\s/g, '')}`;
}

export function getProfileImageSrc(img: string | undefined | null): string | undefined {
  if (!img) return undefined;
  return normalizeProfileImage(img);
}

export function pickProfileImageRaw(user: Record<string, unknown> | null | undefined): string | undefined {
  if (!user) return undefined;
  const raw =
    user.profile_image ??
    user.avatar ??
    user.profileImage ??
    user.avatar_url ??
    user.image ??
    user.image_url ??
    user.profileImageUrl;
  return typeof raw === 'string' ? raw : undefined;
}
